export const API_URL = process.env.REACT_APP_API_URL;
export const NOTIFICATION_URL = process.env.REACT_APP_NOTIFICATION_URL;